<p>
  <span class="countdown-text">
    {{ currentCount }}
  </span>
</p>
